import { IframeBridge } from 'wisper-rpc';

export function clearViewSessionId() {
    const iframe = Array.from(document.querySelectorAll("iframe"))
        .find(f => f.src.includes("everpass-player"));

    if (iframe) {
        const bridge = new IframeBridge(iframe.contentWindow);

        bridge.invoke("clearViewSessionId");
    }
}
